export enum EllipsisButtonType {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  HAMBURGER = 'hamburger',
  DOWN = 'down',
  CHART = 'chart',
}
